// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Ku3A_xaaI3zlGed8O9gs {
  border: 1px solid #c7c7c7;
  border-radius: 0;
  cursor: pointer;
}

#XSpytKfo2HdPFgN3DvkC {
  color: #333;
  font-size: 14px;
  font-weight: 700;
}

#Rz2mO_XYLYzc94II0gNb {
  color: #333;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  margin: 0 12px 5px;
  padding: 0;
  text-transform: none;
}

#rkCO6AZqR3fYa7HdydVu {
  border-radius: 0;
  margin-top: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

#mTd4Wng9l4n3tgu9RyiC {
  color: #484848;
  cursor: pointer;
  padding: 8px 22px;
}
#mTd4Wng9l4n3tgu9RyiC > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#mTd4Wng9l4n3tgu9RyiC:hover {
  background-color: #e3e3e3;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/layout-editor/components/select-layout/select-layout.module.scss"],"names":[],"mappings":"AACA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,yCAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAAF;AAEE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,yBAAA;AADJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n#control {\n  border: 1px solid #c7c7c7;\n  border-radius: 0;\n  cursor: pointer;\n}\n\n#placeholder {\n  color: #333;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n#group_heading {\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n  margin: 0 12px 5px;\n  padding: 0;\n  text-transform: none;\n}\n\n#menu {\n  border-radius: 0;\n  margin-top: 0;\n  box-shadow: 0 2px 4px rgba($color: #000000, $alpha: 0.25);\n}\n\n#option {\n  color: #484848;\n  cursor: pointer;\n  padding: 8px 22px;\n\n  & > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    background-color: #e3e3e3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"control": `Ku3A_xaaI3zlGed8O9gs`,
	"placeholder": `XSpytKfo2HdPFgN3DvkC`,
	"group_heading": `Rz2mO_XYLYzc94II0gNb`,
	"menu": `rkCO6AZqR3fYa7HdydVu`,
	"option": `mTd4Wng9l4n3tgu9RyiC`
};
export default ___CSS_LOADER_EXPORT___;
